// Single-binding payment hook. The CdvPurchase listener MUST be bound exactly
// once for the app's lifetime — re-binding on every render produces duplicate
// receipt writes per transaction. We use a ref so the bound closure always sees
// the latest subscription helpers without re-binding.
import { useEffect, useRef } from 'react';
import * as appleProvider from '../services/appleProvider';

export default function usePayment(subscription) {
  const subscriptionRef = useRef(subscription);
  subscriptionRef.current = subscription;

  useEffect(() => {
    if (!appleProvider.isAvailable()) return undefined;

    let cancelled = false;
    appleProvider.initializeStore().catch((err) => {
      console.warn('Apple store init failed:', err.message);
    });

    const off = appleProvider.onSubscriptionUpdate((update) => {
      if (cancelled) return;
      // `approved` emits the optimistic tier update; the provider's `verified`
      // handler writes the backend row via silentFetch and only then emits
      // { refetch: true }. Refresh on that signal alone — refreshing earlier
      // races the row write and reads back Free.
      if (!update?.refetch) return;
      const refresh = subscriptionRef.current?.refreshSubscription;
      if (typeof refresh === 'function') {
        refresh().catch(() => {});
      }
    });

    return () => { cancelled = true; off(); };
    // EMPTY deps — listener bound exactly once per app lifetime.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
